import React, { useState, useEffect } from "react";
import { sample } from "lodash";
import ReactPlayer from "react-player";

const videoOptions = [
  "MGS22_1_slow",
  "MGS22_2_slow",
  "MGS22_3_slow",
  "MGS22_4_slow",
  "MGS22_5_slow",
  "MGS22_6_slow",
  "MGS22_7_slow",
  "MGS22_8_slow",
];

const QUERY = "(prefers-reduced-motion: no-preference)";
function usePrefersReducedMotion() {
  // Default to no-animations, since we don't know what the
  // user's preference is on the server.
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(true);
  useEffect(() => {
    const mediaQueryList = window.matchMedia(QUERY);
    // Set the true initial value, now that we're on the client:
    setPrefersReducedMotion(!window.matchMedia(QUERY).matches);
    // Register our event listener
    const listener = (event) => {
      setPrefersReducedMotion(!event.matches);
    };
    mediaQueryList.addEventListener("change", listener);
    return () => {
      mediaQueryList.removeEventListener("change", listener);
    };
  }, []);
  return prefersReducedMotion;
}

const HomeVideo = () => {
  const [video, setVideo] = useState(null);
  useEffect(() => {
    setVideo(sample(videoOptions));
  }, []);

  const prefersReducedMotion = usePrefersReducedMotion();

  if (!video) return null;
  return (
    <ReactPlayer
      url={[
        { src: `assets/${video}.webm`, type: "video/webm" },
        { src: `assets/${video}_c.mp4`, type: "video/mp4" },
      ]}
      playing={!prefersReducedMotion}
      loop
      muted
      playsinline
      width="100%"
      height="100%"
    />
  );
};

export default HomeVideo;



// WEBPACK FOOTER //
// ./src/components/Home/HomeVideo.jsx